export var findRouteFromList = function (_a) {
    var routeName = _a.routeName, menuName = _a.menuName, routePath = _a.routePath;
    return function (item) {
        if (routePath === '/' &&
            item.config &&
            item.config.routePath &&
            item.config.routePath === '/') {
            return true;
        }
        if (routeName &&
            item.config &&
            item.config.routeName &&
            routeName.indexOf(item.config.routeName) !== -1) {
            // получаем часть имени роута первую
            // например в foo-bar.baz будет foo-bar
            var firstRoutenamePart = routeName.replace(/^([\w-]+)\..*$/, '$1');
            return firstRoutenamePart === item.config.routeName;
        }
        if (routePath && item.config && item.config.routePath) {
            // получаем часть урла первую
            // например в урле /foo-bar/baz будет /foo-bar
            var firstRoutePart = routePath.replace(/^(\/[a-zA-Z-_0-9]+)[/?].*$/, '$1');
            return firstRoutePart === item.config.routePath;
        }
        return menuName && item.name === menuName;
    };
};
